/* @ngInject */
function AttachmentLogsSliderController ($scope, SliderService) {
  $scope.sliderClass = 'attachment-logs-slider'

  $scope.$watch('$$childHead', function () {
    if ($scope.$$childHead) {
      $scope.setOpenSettings({ left: '0' }, 400)
      $scope.setCloseSettings({ left: '-100%' }, 400)

      SliderService.register($scope.sliderClass)
      SliderService.registerState($scope.sliderClass, 'open', data => {
        const content = $scope.$$childHead

        content.attachmentStatistics = {
          id: data.attachmentId
        }
        content._postId = data.postId
        content.getLogs()
        $scope.setSliderOpen(true)
      })

      SliderService.registerState($scope.sliderClass, 'close', () => {
        $scope.setSliderOpen(false)
      })
    }
  })
}

export { AttachmentLogsSliderController }
